import apiClient from '../apiClient';
import { GET_MASTER_REFERENCE_MENU_TYPE_LIST_URL } from '../apiUrl';

const getMenuItemApi = () => {
  return apiClient.get(GET_MASTER_REFERENCE_MENU_TYPE_LIST_URL);
};

export default getMenuItemApi;
